import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomainPath} from '@twpub/core/models';

import {RouterLink} from '@angular/router';

@Component({
  selector: 'pub-domain-breadcrumbs',
  templateUrl: './domain-breadcrumbs.component.html',
  styleUrls: ['./domain-breadcrumbs.component.scss'],
  standalone: true,
  imports: [RouterLink]
})
export class DomainBreadcrumbsComponent {
  @Input() path?: DomainPath = {path: []};
  @Output() selectDomains = new EventEmitter<number[]>()
}
